export const shop_hand_soap = [
  {
    id: "ik1",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw4a2daeae/crop/026518035_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    name: "Ghoul riend",
    category1: "Cleansing Gel Hand Soap",
    Amount: "7.50",
    Rating: "4.5",
    desc: "Mix & Match 5/$25",
  },
  {
    id: "ik1.5",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwd9f6c0b5/crop/026529409_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    name: "Sugar Spell",
    category1: "Gentle Foaming Hand Soap",
    Amount: "8.50",
    Rating: "3.5",
    desc: "Mix & Match 5/$25",
  },
  {
    id: "ik2",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw4092ec1c/crop/026557020_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    name: "Trick or Treat",
    category1: "PocketBac Hand Sanitizer, 5-Pack",
    Amount: "8.00",
    Rating: "5",
    desc: "Mix & Match 5/$25",
  },
  {
    id: "ik3",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw3e04d4d8/crop/026526089_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    name: "Vampire Blood",
    category1: "Gentle Foaming Hand Soap",
    Amount: "7.50",
    Rating: "4",
    desc: "Mix & Match 5/$25",
  },
  {
    id: "ik4",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw59fe8c19/crop/026526091_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    name: "Purrfect Pumpkin",
    category1: "Gentle Foaming Hand Soap",
    Amount: "7.50",
    Rating: "5",
    desc: "Mix & Match 5/$25",
  },
  {
    id: "ik5",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw7cdf81da/crop/026526733_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    name: "Vampire Blood",
    category1: "Hand Sanitizer",
    Amount: "6.50",
    Rating: "5",
    desc: "Mix & Match 5/$25",
  },
  {
    id: "ik6",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwd899059f/crop/026529408_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    name: "Stardust Magic",
    category1: "Gentle Foaming Hand Soap",
    Amount: "8.50",
    Rating: "3.5",
    desc: "Mix & Match 5/$25",
  },
  {
    id: "ik7",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw6d1ecec6/crop/026490031_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    name: "Boardwalk Vanilla Cone",
    category1: "Gentle Foaming Hand Soap",
    Amount: "7.50",
    Rating: "5",
    desc: "Mix & Match 5/$25",
  },
  {
    id: "ik8",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw2f53c870/crop/026487385_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    name: "Berry Waffle Cone",
    category1: "Gentle Foaming Hand Soap",
    Amount: "7.50",
    Rating: "3",
    desc: "Mix & Match 5/$25",
  },
  {
    id: "ik9",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw6d5e64ca/crop/026490034_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    name: "Sunshine & Lemons",
    category1: "Gentle Foaming Hand Soap",
    Amount: "7.50",
    Rating: "4.5",
    desc: "Mix & Match 5/$25",
  },
  {
    id: "ik11",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwfb22f0dc/crop/026487392_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    name: "Sun-Washed Citrus",
    category1: "Gentle Foaming Hand Soap",
    Amount: "7.50",
    Rating: "3",
    desc: "Mix & Match 5/$25",
  },
  {
    id: "ik12",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw0fdde25d/crop/026495972_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    name: "Sunny Squeeze",
    category1: "Gentle Foaming Hand Soap",
    Amount: "7.50",
    Rating: "5",
    desc: "Mix & Match 5/$25",
  },
  {
    id: "ik13",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwf03cd9f4/crop/026460821_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New Fragrance",
    name: "Kitchen Lemon",
    category1: "Gentle Foaming Hand Soap",
    Amount: "8.50",
    Rating: "3.5",
    desc: "Mix & Match 5/$25",
  },
  {
    id: "ik14",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw632f0f2e/crop/026470439_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    name: "Sea Salt & Lime",
    category1: "Gentle Gel Hand Soap",
    Amount: "7.50",
    Rating: "4",
    desc: "Mix & Match 5/$25",
  },
  {
    id: "ik15",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwf0f64f42/crop/026490035_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    name: "Oceanfront Garden",
    category1: "Gentle Foaming Hand Soap",
    Amount: "7.50",
    Rating: "5",
    desc: "Mix & Match 5/$25",
  },
  {
    id: "ik16",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwff43fe31/crop/026487391_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    name: "Endless Weekend",
    category1: "Gentle Foaming Hand Soap",
    Amount: "7.50",
    Rating: "5",
    desc: "Mix & Match 5/$25",
  },
  {
    id: "ik17",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw04740286/crop/026487386_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    name: "Island Punch",
    category1: "Gentle Foaming Hand Soap",
    Amount: "7.50",
    Rating: "3",
    desc: "Mix & Match 5/$25",
  },
  {
    id: "ik18",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwd9b51dce/crop/026474055_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    name: "Lakeside Afternoon",
    category1: "Gentle Gel Hand Soap",
    Amount: "7.50",
    Rating: "3",
    desc: "Mix & Match 5/$25",
  },
  {
    id: "ik19",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwd9b51dce/crop/026474055_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    name: "Lakeside Afternoon",
    category1: "Gentle Gel Hand Soap",
    Amount: "7.50",
    Rating: "3",
    desc: "Mix & Match 5/$25",
  },
  {
    id: "ik20",
    pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwd9b51dce/crop/026474055_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
    category: "New!",
    name: "Lakeside Afternoon",
    category1: "Gentle Gel Hand Soap",
    Amount: "7.50",
    Rating: "3",
    desc: "Mix & Match 5/$25",
  },
];
